import { COMPANY_ROUTE } from '@constants'

// post-it
export const API_POST_IT_LIST_URL = `${COMPANY_ROUTE}postit/{document_type}/{document_id}/`
export const API_POST_IT_DETAIL_URL = `${COMPANY_ROUTE}postit/{document_type}/{document_id}/{post_it_id}/`
export const API_POST_IT_TOOLTIP_URL = `${COMPANY_ROUTE}postit-tooltip/{document_type}/{document_id}/`
